export const wsTAOAbi = [
  {
    type: 'function',
    name: 'wrap',
    stateMutability: 'payable',
    inputs: [
      { name: 'minSharesOut', type: 'uint256' },
      { name: 'deadline', type: 'uint256' },
    ],
    outputs: [{ name: 'sharesOut', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'exchangeRate',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  // Canonical wsTAO discriminator: mirrors PositionRouter._isWsTAOUnderlying so
  // the FE and contract dispatch against the same ground truth (not the mutable symbol).
  {
    type: 'function',
    name: 'wsTAOColdkey',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'bytes32' }],
  },
] as const;

// WAlpha.exchangeRate returns alpha base units (9 decimals) per 1e18 wAlpha base units.
export const wAlphaAbi = [
  {
    type: 'function',
    name: 'wrap',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'alphaIn', type: 'uint256' },
      { name: 'minWAlphaOut', type: 'uint256' },
    ],
    outputs: [{ name: 'wAlphaOut', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'wrap',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'alphaIn', type: 'uint256' },
      { name: 'minWAlphaOut', type: 'uint256' },
      { name: 'deadline', type: 'uint256' },
    ],
    outputs: [{ name: 'wAlphaOut', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'unwrap',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'wAlphaIn', type: 'uint256' },
      { name: 'minAlphaOut', type: 'uint256' },
    ],
    outputs: [{ name: 'alphaOut', type: 'uint256' }],
  },
  // Deadline-protected unwrap (mempool/MEV defense per audit INFO-3). Matches
  // WAlpha.sol:263.
  {
    type: 'function',
    name: 'unwrap',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'wAlphaIn', type: 'uint256' },
      { name: 'minAlphaOut', type: 'uint256' },
      { name: 'deadline', type: 'uint256' },
    ],
    outputs: [{ name: 'alphaOut', type: 'uint256' }],
  },
  // unwrapTo overloads — forwards unwrapped alpha to user's mapped coldkey
  // directly (no router hop). Used by PositionRouter._doRedeemAlpha / _doBorrowAlpha.
  {
    type: 'function',
    name: 'unwrapTo',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'recipient', type: 'address' },
      { name: 'wAlphaIn', type: 'uint256' },
      { name: 'minAlphaOut', type: 'uint256' },
    ],
    outputs: [{ name: 'alphaOut', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'unwrapTo',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'recipient', type: 'address' },
      { name: 'wAlphaIn', type: 'uint256' },
      { name: 'minAlphaOut', type: 'uint256' },
      { name: 'deadline', type: 'uint256' },
    ],
    outputs: [{ name: 'alphaOut', type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'exchangeRate',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'netuid',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint16' }],
  },
  {
    type: 'function',
    name: 'hotkey',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'bytes32' }],
  },
] as const;
